import { LearningObject } from '../';
import type { IJobAid } from '.';

export class JobAid extends LearningObject implements IJobAid {}
